import { createUseStyles } from 'react-jss'


export default createUseStyles({
  container: {
    height: 'calc(var(--vh, 1vh) * 100)',
    display: 'flex',
    flexFlow: 'row wrap',
    justifyContent: 'flex-start',
    alignItems: 'center',
    fallbacks: {
      height: '100vh',
    },
    '& > *': {
      width: '100%',
    },
  },
})
